/**
 * Visibilidad de documentos del edificio (`buildingdocs.visibilidad`).
 *
 * El admin elige por documento quién lo ve:
 *   - "ninguno":      solo la administración (no lo ve ningún residente).
 *   - "propietarios": solo propietarios.
 *   - "todos":        propietarios e inquilinos.
 * Regla: si lo ve el inquilino, lo ve el propietario (los niveles son acumulativos).
 * Docs legacy sin el campo se tratan como "todos" (era el comportamiento previo).
 */
export const DOC_VISIBILITY = {
  NINGUNO: "ninguno",
  PROPIETARIOS: "propietarios",
  TODOS: "todos",
};

export const VISIBILITY_OPTIONS = [
  { value: DOC_VISIBILITY.TODOS, label: "Propietarios e inquilinos" },
  { value: DOC_VISIBILITY.PROPIETARIOS, label: "Solo propietarios" },
  { value: DOC_VISIBILITY.NINGUNO, label: "Ninguno (solo administración)" },
];

export function normalizeVisibility(v) {
  return v === DOC_VISIBILITY.NINGUNO || v === DOC_VISIBILITY.PROPIETARIOS ? v : DOC_VISIBILITY.TODOS;
}

export function visibilityLabel(v) {
  const n = normalizeVisibility(v);
  return VISIBILITY_OPTIONS.find((o) => o.value === n).label;
}

/**
 * ¿El residente es propietario en el edificio? Mira sus unidades vigentes
 * (userUnitsInBuilding del BuildingContext); si solo tiene históricas, usa esas.
 */
export function isOwnerInBuilding(units) {
  const list = Array.isArray(units) ? units : [];
  const current = list.filter((u) => !u.isHistorical);
  const base = current.length ? current : list;
  return base.some((u) => u.userRole === "Propietario");
}

/** ¿Puede este residente ver el documento? */
export function canResidentSeeDoc(docItem, isOwner) {
  const v = normalizeVisibility(docItem && docItem.visibilidad);
  if (v === DOC_VISIBILITY.TODOS) return true;
  if (v === DOC_VISIBILITY.PROPIETARIOS) return !!isOwner;
  return false;
}
